/* PETQuarters: Selly (Treedify) sale-offer reader for collection cards.
 * Selly publishes its live offer configuration to every page through window.tdfEventHub ('data_app2') — the same
 * data its own "NN% OFF" label and PDP sale widget are drawn from. This module only READS that payload and exposes
 * the per-variant promo price so cards can show the same sale price the PDP shows. Conservative by design:
 *   - only "Sale" offers (type 1) with a plain percentage discount (discount.type_id 1) or a fixed per-unit sale
 *     price (discount.type_id 7, e.g. "$5.99") are used — both are per-unit prices the PDP widget shows verbatim;
 *   - bundle / BOGO / quantity offers are ignored (their price is not a per-unit price);
 *   - the offer must be inside its schedule window right now; offers with weekly/monthly windows are skipped;
 *   - product groups: type 3 = whole product, type 2 = product with optional per-variant list (pvids);
 *   - promo cents = floor(regular cents x (100 - pct) / 100), matching Selly's own rounding ($74.99 @ 50% -> $37.49).
 * No network calls of its own, nothing written anywhere. If Selly is absent or late, cards simply keep the regular price. */
(() => {
  'use strict';
  if (window.PQSelly) return;
  const byProduct = new Map(); // productId -> [{pct,label,variants:Set|null}]
  let ready = false, raw = null;
  function now() { return Math.floor(Date.now() / 1000); }
  function scheduleActive(d, ids) {
    if (!Array.isArray(ids) || !ids.length) return false;
    const t = now();
    return ids.some(id => {
      const s = d.schedules && d.schedules[id]; if (!s) return false;
      if ((s.w && s.w.d != null) || (s.m && s.m.d != null)) return false;
      const st = Number(s.st && s.st.s) || 0, et = Number(s.et && s.et.s) || 0;
      return st <= t && (et === 0 || t < et);
    });
  }
  function index(d) {
    byProduct.clear();
    const sales = d && d.offers && d.offers['1'];
    if (!sales) return;
    for (const o of Object.values(sales)) {
      const disc = o && o.discount; if (!disc) continue;
      const dtype = Number(disc.type_id);
      let pct = 0, fixed = 0;
      if (dtype === 1) { pct = Number(disc.value); if (!(pct > 0 && pct < 100)) continue; }
      else if (dtype === 7) { fixed = Math.round(Number(disc.value) * 100); if (!(fixed > 0)) continue; }
      else continue;
      if (!scheduleActive(d, o.trigger && o.trigger.schedule_ids)) continue;
      const label = String(o.label || (o.trigger && o.trigger.label) || '').trim();
      for (const g of o.product_groups || []) {
        const type = Number(g.type_id); if (type !== 2 && type !== 3) continue;
        for (const pid of g.ids || []) {
          const key = String(pid);
          const pv = type === 2 && g.pvids && g.pvids[key];
          const entry = { pct, fixed, label, variants: Array.isArray(pv) && pv.length ? new Set(pv.map(String)) : null };
          if (!byProduct.has(key)) byProduct.set(key, []);
          byProduct.get(key).push(entry);
        }
      }
    }
  }
  function offerFor(productId, variantId, regularCents) {
    if (!ready) return null;
    const list = byProduct.get(String(productId)); if (!list) return null;
    const cents = Number(regularCents); if (!(Number.isFinite(cents) && cents > 0)) return null;
    let best = null, bestCents = 0;
    for (const e of list) {
      if (e.variants && !e.variants.has(String(variantId))) continue;
      const promo = e.fixed ? e.fixed : Math.floor(cents * (100 - e.pct) / 100); // lowest resulting price wins
      if (!(promo > 0 && promo < cents)) continue;
      if (!best || promo < bestCents) { best = e; bestCents = promo; }
    }
    if (!best) return null;
    const pct = best.pct || Math.round((1 - bestCents / cents) * 100);
    return { cents: bestCents, pct, label: best.label || (best.fixed ? 'SALE' : best.pct + '% OFF') };
  }
  function onData(_name, d) {
    try { raw = d; index(d); ready = true; } catch (e) { ready = false; return; }
    document.dispatchEvent(new CustomEvent('pq:selly-ready'));
  }
  let tries = 0;
  (function hook() {
    const hub = window.tdfEventHub;
    if (hub && typeof hub.ListenToEvent === 'function') { try { hub.ListenToEvent('data_app2', onData, true); } catch (e) { /* no Selly */ } return; }
    if (++tries < 80) setTimeout(hook, 250); // up to ~20s for Selly's loader; otherwise cards keep regular prices
  })();
  // Re-evaluate schedule windows once a minute so an offer that starts/ends while the page is open updates in place.
  setInterval(() => { if (raw) { index(raw); document.dispatchEvent(new CustomEvent('pq:selly-ready')); } }, 60000);
  window.PQSelly = { offerFor, isReady: () => ready };
})();
